import { useEffect } from 'react';
import { addDependentEntities } from '../modules/utils/services/dependentEntities';
export default function useQueryKeys({
  path,
  customQueryKey = '',
  options = {},
  watchedQueryKeys = []
}: {
  path: string;
  customQueryKey?: string;
  options?: Record<string, any>;
  watchedQueryKeys?: string[];
}) {
  useEffect(() => {
    if (watchedQueryKeys.length > 0) {
      addDependentEntities(path, watchedQueryKeys);
      if (customQueryKey) {
        addDependentEntities(customQueryKey, watchedQueryKeys);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path, customQueryKey, ...watchedQueryKeys]);
  const queryKey = [path, options];
  if (customQueryKey) {
    queryKey.unshift(customQueryKey);
  }
  return queryKey;
}